(function () {
  function initSliders() {
    document.querySelectorAll(".adv-section").forEach(section => {
      if (section.dataset.sliderReady === "true") return;

      const id = section.dataset.sectionId;
      const slider = section.querySelector(`[data-slider-id="${id}"]`);
      if (!slider) return;

      section.dataset.sliderReady = "true";

      const dots = section.querySelectorAll(`[data-dots-id="${id}"] span`);
      const left = section.querySelector(`.adv-arrow.left[data-slider="${id}"]`);
      const right = section.querySelector(`.adv-arrow.right[data-slider="${id}"]`);

      let index = 0;
      const total = slider.children.length;
      if (total === 0) return;

      const auto = section.dataset.auto === "true";
      const duration = Math.max(2000, Number(section.dataset.duration || 5) * 1000);
      let timer = null;

      /* Update Slide & Active Dot */
      function show(i) {
        index = (i + total) % total;
        slider.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((d, idx) => {
          if (idx === index) {
            d.classList.add("active");
          } else {
            d.classList.remove("active");
          }
        });
      }

      /* Auto-slide controls */
      function startAuto() {
        if (!auto || total <= 1) return;
        stopAuto();
        timer = setInterval(() => {
          show(index + 1);
        }, duration);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      /* Navigation click handlers */
      if (right) {
        right.addEventListener("click", e => {
          e.preventDefault();
          show(index + 1);
          startAuto();
        });
      }

      if (left) {
        left.addEventListener("click", e => {
          e.preventDefault();
          show(index - 1);
          startAuto();
        });
      }

      dots.forEach(dot => {
        dot.addEventListener("click", () => {
          const targetIndex = Number(dot.dataset.index);
          show(targetIndex);
          startAuto();
        });
      });

      /* Pause auto slide on hover (Desktop) */
      section.addEventListener("mouseenter", stopAuto);
      section.addEventListener("mouseleave", startAuto);

      /* Touch Swipe handling */
      let startX = 0;
      let startY = 0;
      let isSwiping = false;

      slider.addEventListener("touchstart", e => {
        if (e.touches.length > 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isSwiping = true;
        stopAuto();
      }, { passive: true });

      slider.addEventListener("touchend", e => {
        if (!isSwiping) return;
        isSwiping = false;
        const diffX = startX - e.changedTouches[0].clientX;
        const diffY = startY - e.changedTouches[0].clientY;

        // Ensure swipe was primarily horizontal
        if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX > 0) {
            show(index + 1);
          } else {
            show(index - 1);
          }
        }
        startAuto();
      }, { passive: true });

      /* Initialize without layout delay */
      show(0);
      startAuto();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSliders);
  } else {
    initSliders();
  }

  // Support Shopify Theme Editor dynamic reloads
  document.addEventListener("shopify:section:load", initSliders);
})();
